module.exports = __webpack_public_path__ + "media/application/images/ui/icon-menu-hamburgerx2-025de11f695e3cff529ad29e2e54f601.png";